export const sum = arr => arr.reduce((acc, n) => acc + n, 0);
//# sourceMappingURL=index.js.map